angular.module('dpw.services')

    /**
     * Google reCAPTCHA class
     *
     * @param {String} elementId - ID of an element where you wish to display Google reCAPTCHA.
     * @param {Object} [params] - Parameters for the rendering of Google reCAPTCHA.
     *
     * @Example
     * $ctrl.googleRecaptcha = new GoogleRecaptcha('google-recaptcha', {
     *     // Docs for the parameters can be found in: https://developers.google.com/recaptcha/docs/display#render_param
     * });
     *
     * @Note
     * Create a GoogleRecaptcha instance after the DOM is ready.
     */
    .factory('GoogleRecaptcha', ['$window', '$q', function ($window, $q) {
        var settings = {
            siteKey: _.get(RCDPW, 'googleReCaptchaKey', '6Lcyp9YpAAAAAHxcTOtAfw9tbGu5IcERkLSF4B00')
        };

        var deferred = $q.defer();
        loadResources();

        var GoogleRecaptcha = function (elementId, params) {
            this.elementId = elementId;
            this.params = params;
            this.render();
        };

        _.assign(GoogleRecaptcha.prototype, {
            render: function () {
                var self = this;
                deferred.promise.then(function () {
                    var recaptcha = self._getRecaptcha();
                    self.widgetId = recaptcha.render(self.elementId, _.assign({
                        'sitekey': settings.siteKey
                    }, self.params));
                });
            },

            getResponse: function () {
                var recaptcha = this._getRecaptcha();
                return _.isUndefined(this.widgetId) ? '' : recaptcha.getResponse(this.widgetId);
            },

            reset: function () {
                var recaptcha = this._getRecaptcha();
                !_.isUndefined(this.widgetId) && recaptcha.reset(this.widgetId);
            },

            _getRecaptcha: function () {
                return _.get($window, 'grecaptcha');
            }
        });

        return GoogleRecaptcha;

        function loadResources() {
            var baseUrl = 'https://www.google.com/recaptcha/api.js';
            var params = {
                hl: 'en',
                render: 'explicit',
                onload: 'onGoogleRecaptchaLoad',
                r: Math.random()
            };

            var paramsString = _.map(params, function (value, key) {
                return [key, value].join('=');
            }).join('&');

            var requestUrl = [baseUrl, paramsString].join('?');

            $window.onGoogleRecaptchaLoad = function () {
                deferred.resolve();
            };

            $.getScript(requestUrl);
        }
    }])

;
